module.exports = __webpack_public_path__ + "static/img/18.4059f4d2.png";